import { Component } from 'react';

interface Props {
    content: React.ReactNode;
}

class PdfData extends Component<Props> {
    render() {
        return (
            <>
                {this.props.content}
            </>
        );
    }
}

export default PdfData;
